import { CSSObject } from '@chakra-ui/react';

export const SideNavHeading: CSSObject = {
  '&&': {
    mb: '0',
  },
};
